import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 1rem;
  & > h3 {
    font-weight: bold;
    margin-bottom: 2rem;
    font-size: 1rem;
  }
  .mdc-chip--selected {
    cursor: default;
    pointer-events: none;
  }
`;

export const ModalOverride = styled.div`
  .hefesto-title h3 {
    color: ${({ theme }) => theme.colors.grayDark3};
    margin-bottom: 24px;
  }
  .hefesto-modal__header {
    margin-bottom: 0;
  }

  .hefesto-modal__body {
    margin-bottom: 0px;
  }

  .hefesto-modal__body > div:first-child {
    gap: 16px;
  }

  .mdc-chip-set {
    padding-left: 0;
    padding-top: 0;
  }

  .mdc-chip-set .mdc-chip .mdc-chip__text {
    margin-right: 0;
  }

  .hefesto-chip .mdc-chip {
    border-width: 1px;
    padding: 16px;
    margin-left: -2px;
    margin-right: 16px;
    padding: 15px 7px 16px 12px;
    letter-spacing: 0.2px;
  }

  .hefesto-chip .mdc-chip.mdc-chip--selected {
    color: ${({ theme }) => theme.colors.blue6};
    background-color: rgb(220, 235, 255);
    border: 3px solid ${({ theme }) => theme.colors.blue4};
    padding-right: 9px;
  }

  .hefesto-checkbox {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .mdc-chip-set .mdc-chip {
    margin-right: 22px;
  }

  .hefesto-checkbox {
    gap: 0.925rem;
  }

  .hefesto-checkbox__item-check {
    transform: scale(2);
  }

  .hefesto-modal__body {
    overflow: inherit;
  }

  .hefesto-modal__body > div > div:nth-child(2) > div {
    gap: 1.5rem;
  }

  .hefesto-input-wrapper__label-wrapper__label {
    padding-left: 17px;
  }

  .hefesto-textfield input {
    padding-left: 15px;
  }

  .hefesto-modal__body > div > div:nth-child(4) > span {
    padding-top: 0;
  }
  .hefesto-modal__body > div > div:nth-child(4) > div {
    padding-top: 0.5rem;
    width: 10.2rem;
  }

  .hefesto-modal__footer {
    gap: 15px;
  }

  .hefesto-button {
    max-height: 2.5rem;
  }
`;

export const TypeNumberLinesContainer = styled.div`
  margin-top: 0;
`;

export const TextfieldWrapper = styled.div`
  width: 12rem;
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-left: 3px;
  gap: 26px;
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 162px;
`;

export const ColumnsDataContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 0.5rem;
`;

export const Title = styled.span<{ bold?: boolean; isTitle?: boolean }>`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grayDark3};
`;
